export const inEnglandQuestion = 'In England?';
export const NHSLoginError = 'Something went wrong. Please try again.';

export const englandLoginTitle = 'Choose your login method';
export const englandLoginSubtitle =
  'Use the same login method that you created your account with.';

export const accessNHS = 'Free access through the NHS';
export const accessResearch = 'I am part of a Research Study';
export const accessEmployer = 'I work for Google';
